

































































import Vue from 'vue'
import models from '@/mixins/models-mixin'
import GroupQueryForm from '@/components/GroupQueryForm.vue'
import GroupStaticForm from '@/components/GroupStaticForm.vue'
export default Vue.extend({
    mixins: [models],
    components: { GroupQueryForm, GroupStaticForm },
    props: {
        //  Disables the form
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            group: null,
            selectedIndex: null,
            step: 1,
            maxWidth: '600px',
            cards: [
                {
                    title: 'Select from your existing contacts',
                    text: `Search for existing contacts and add them one-by-one to create a new group.`,
                    img: 'selectExisting'
                },
                {
                    title: 'Upload a new contact list',
                    text: `Upload a list of new contacts from a .csv file to create a new group.`,
                    img: 'uploadDocument'
                },
                {
                    title: 'Set filters based on contact properties',
                    text: `Set filters based on contact properties to define which contacts automatically filter into this group.`,
                    img: 'filterIcon'
                }
            ]
        }
    },
    computed: {
        query(): string | null {
            //  IF we have teh goto query, return it
            if (this.$route.query.goto) {
                return '&goto=' + window.toUrlParams(this.$route.query.goto)
            }
            return null
        }
    },
    methods: {
        boxStyle(index: null): object {
            return {
                border: `1px solid ${this.$colors.primary}`,
                borderRadius: '10px',
                padding: '16px',
                marginBottom: '10px',
                color: 'black',
                backgroundColor:
                    this.selectedIndex === index ? this.$colors.mdLightPurple50 : null
            }
        },
        goToNextStep(): void {
            //  Select the type of group the user wants to create
            const type = {
                0: 'static',
                1: 'csv',
                2: 'query'
            }[this.selectedIndex]

            //  If the user selected 'CSV' route to csv import, if goto param is set, forward that with next route
            if (type === 'csv')
                return this.$router.push(
                    `/csv/import?new_group=true${
                        this.$route.query.goto ? `&goto=${this.$route.query.goto}` : ''
                    }`
                )
            //  If the user selected 'static' go to step 2
            else if (type === 'static') {
                this.group = this.newStaticGroup()
                this.step = 2
            }

            //  If the user selected 'query' go to step 3
            else if (type === 'query') {
                this.group = this.newQueryGroup()
                this.step = 3
            }
        }
    }
})
